import type { FamilyMember } from '../../hooks/useFamilyMembers'

export type FamilyRowAction = 'resend' | 'edit' | 'delete'

/** Row actions available for a member; resend only applies to pending invites. */
export const familyRowActions = (
  member: Pick<FamilyMember, 'isAccepted'>
): FamilyRowAction[] =>
  member.isAccepted ? ['edit', 'delete'] : ['resend', 'edit', 'delete']
